/* Thermal Bros species/activity hunting-law selector: source-based, progressive enhancement. */
(() => {
  'use strict';
  const clean = value => String(value || '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
  const statusKind = v => v === 'yes' ? 'allowed' : v === 'no' ? 'restricted' : 'verify';
  const statusLabel = v => v === 'yes' ? 'YES · requirements apply' : v === 'no' ? 'NO' : 'NEEDS VERIFICATION';
  const animalText = v => ({coyote:'Coyotes',hog:'Feral hogs / wild pigs',raccoon:'Raccoons',nongame:'Other nongame wildlife'})[v] || 'Coyotes';
  const activityText = {night:'Hunting after dark',hunt:'Thermal while hunting at night',scout:'Thermal scouting before a hunt'};
  const publicNote = 'Public-land rules vary by wildlife area, WMA, season and land manager. A private-land exception does not establish permission on public land. Open this state guide and verify the exact unit before hunting.';
  const getValue = (row, animal, activity, land) => {
    const key = `${animal}-${activity}`;
    const base = row.getAttribute(`data-${key}`) || 'check';
    const detail = row.getAttribute(`data-${key}-detail`) || '';
    if (land === 'public' && base !== 'no') return {value:'check', detail:publicNote};
    return {value:base,detail};
  };
  const changePill = (node,status) => {
    if (!node) return;
    const pill = node.querySelector('.tb-law-status') || node;
    if (!pill.classList.contains('tb-law-status')) return;
    pill.className = `tb-law-status tb-law-status--${statusKind(status)}`;
    pill.dataset.statusKind = statusKind(status);
    const words = pill.querySelector('span:last-child');
    if (words) words.textContent = statusLabel(status);
  };
  const params = new URLSearchParams(location.search);
  const defaultChoice = key => ({animal:['coyote','hog','raccoon','nongame'],activity:['night','hunt','scout'],land:['private','public']}[key].includes(params.get(key)) ? params.get(key) : ({animal:'coyote',activity:'night',land:'private'}[key]));
  const hub = document.querySelector('[data-tb-laws-hub]');
  if (hub) {
    const search = hub.querySelector('[data-law-search]');
    const activitySelect = hub.querySelector('[data-law-activity]');
    const landSelect = hub.querySelector('[data-law-land]');
    const animalButtons = [...hub.querySelectorAll('[data-law-animal]')];
    const reset = hub.querySelector('[data-law-clear]');
    const count = hub.querySelector('[data-law-count]');
    const empty = hub.querySelector('[data-law-no-results]');
    const rows = [...hub.querySelectorAll('[data-law-row]')];
    const mapLinks = [...hub.querySelectorAll('[data-map-state]')];
    const rowByCode = new Map(rows.map(row => [row.dataset.state,row]));
    let animal = defaultChoice('animal');
    if (activitySelect) activitySelect.value = defaultChoice('activity');
    if (landSelect) landSelect.value = defaultChoice('land');
    const activeAnimal = () => animal;
    const activeActivity = () => activitySelect?.value || 'night';
    const activeLand = () => landSelect?.value || 'private';
    function setStateLinkQuery(anchor) {
      if (!anchor) return;
      const base = anchor.getAttribute('data-base-href') || anchor.getAttribute('href') || '';
      anchor.setAttribute('data-base-href',base);
      if (!base.startsWith('/pages/')) return;
      const qs = new URLSearchParams({animal:activeAnimal(),activity:activeActivity(),land:activeLand()});
      anchor.setAttribute('href', `${base.split('?')[0]}?${qs.toString()}`);
    }
    function render() {
      const activity=activeActivity(),land=activeLand(),term=clean(search?.value);
      for (const button of animalButtons) button.setAttribute('aria-pressed', String(button.dataset.lawAnimal === animal));
      const names = term ? rows.filter(r => clean(r.querySelector('.tb-law-ref-state-cell strong')?.textContent).split(' ').some(w => w.startsWith(term))) : [];
      let visible=0;
      for (const row of rows) {
        const name=clean(row.querySelector('.tb-law-ref-state-cell strong')?.textContent);
        const match = !term || (names.length ? name.split(' ').some(w => w.startsWith(term)) : clean(row.dataset.search).includes(term));
        row.hidden=!match;
        if(match)visible++;
        const result=getValue(row,animal,activity,land);
        changePill(row.querySelector('[data-display-status]'),result.value);
        const why = row.querySelector('[data-law-detail]');
        if (why) why.textContent=result.detail;
        const source = row.querySelector('[data-law-source]');
        if (source) source.setAttribute('href',row.getAttribute(`data-${animal}-source`)||source.href);
        row.querySelectorAll('.tb-law-ref-state-cell a,.tb-law-ref-table-action a').forEach(setStateLinkQuery);
      }
      for (const link of mapLinks) {
        const row=rowByCode.get(link.dataset.state); if (!row) continue;
        const result=getValue(row,animal,activity,land);
        link.classList.remove('tb-law-ref-map-state--allowed','tb-law-ref-map-state--conditional','tb-law-ref-map-state--restricted','tb-law-ref-map-state--verify');
        link.classList.add(`tb-law-ref-map-state--${statusKind(result.value)}`);
        const state = row.querySelector('.tb-law-ref-state-cell strong')?.textContent?.trim() || link.dataset.state;
        const label = `${state} — ${animalText(animal)}, ${activityText[activity]}, ${land} land: ${statusLabel(result.value)}`;
        link.setAttribute('aria-label',label);
        const t=link.querySelector('title');if(t)t.textContent=label;
        link.style.opacity=row.hidden?'.28':'1';
        setStateLinkQuery(link);
      }
      hub.querySelectorAll('.tb-law-ref-smallstates a').forEach(setStateLinkQuery);
      const context=hub.querySelector('[data-law-context]');
      if(context)context.textContent=`${animalText(animal)} · ${activityText[activity]} · ${land==='private'?'Private land':'Public land / WMA'}`;
      const n=hub.querySelector('[data-law-context-note]');
      if(n)n.textContent=land==='public' ? publicNote : animal==='nongame' ? 'Other nongame wildlife is not one uniform category. A YES is restricted to the named qualifying unprotected animals in the cited state rule; never transfer it to other species. Confirm the exact animal, season, method and property.' : 'YES means the cited source supports at least one qualifying private-land pathway. Confirm season dates, licenses, equipment, county rules and landowner permission. This is not a live legality check for tonight.';
      if(count)count.textContent=`${visible} state${visible===1?'':'s'}`;
      if(empty)empty.hidden=visible!==0;
    }
    animalButtons.forEach(b=>b.addEventListener('click',()=>{animal=b.dataset.lawAnimal;render();}));
    activitySelect?.addEventListener('change',render);
    landSelect?.addEventListener('change',render);
    search?.addEventListener('input',render);
    reset?.addEventListener('click',()=>{animal='coyote';if(activitySelect)activitySelect.value='night';if(landSelect)landSelect.value='private';if(search)search.value='';render();search?.focus();});
    render();
  }
  const guide = document.querySelector('[data-tb-state-guide]');
  const panel=guide?.querySelector('[data-state-decisions]');
  if (guide && panel) {
    const animalSelect=guide.querySelector('[data-state-animal]');
    const activitySelect=guide.querySelector('[data-state-activity]');
    const landSelect=guide.querySelector('[data-state-land]');
    if(animalSelect)animalSelect.value=defaultChoice('animal');
    if(activitySelect)activitySelect.value=defaultChoice('activity');
    if(landSelect)landSelect.value=defaultChoice('land');
    function render() {
      const animal=animalSelect?.value||'coyote',activity=activitySelect?.value||'night',land=landSelect?.value||'private';
      const result=getValue(panel,animal,activity,land);
      changePill(guide.querySelector('[data-state-answer-status]'),result.value);
      const heading=guide.querySelector('[data-state-answer-heading]');
      if(heading)heading.textContent=`${animalText(animal)} · ${activityText[activity]}`;
      const p=guide.querySelector('[data-state-answer-explanation]');
      if(p)p.textContent=result.detail;
      const source=guide.querySelector('[data-state-source]');
      if(source)source.setAttribute('href',panel.getAttribute(`data-${animal}-source`)||source.href);
      guide.querySelectorAll('[data-quick-status]').forEach(n=>{
        const r=getValue(panel,animal,n.dataset.quickStatus,land);
        n.textContent=statusLabel(r.value);
        n.className=`tb-state-ref-inline-outcome tb-state-ref-inline-outcome--${statusKind(r.value)}`;
      });
    }
    [animalSelect,activitySelect,landSelect].forEach(s=>s?.addEventListener('change',render));
    render();
  }
})();
